import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedValue } from '../../redux/reducers/dropdownSlice';
import IconCollection from '../../IconCollection/IconCollection';

const CustomDropdownRedux = ({ id, options, customStyle, customStyleDropdownList, liCustomStyle, defaultValue, dropdownContainer }) => {
  const dispatch = useDispatch();
  const selectedValue = useSelector((state) => state.dropdown.dropdowns[id] || defaultValue);

  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    dispatch(setSelectedValue({ id, value }));
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`custom-dropdown relative ${dropdownContainer}`} ref={dropdownRef}>
      <div className={`dropdown-header ${customStyle}`} onClick={toggleDropdown}>
        {selectedValue ? selectedValue : 'Select'}
        <i className={`arrow ${isOpen ? 'up' : 'down'}`} />
        {isOpen ? <IconCollection customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]' name="arrow-up" /> : <IconCollection customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]' name="arrow-down" />}
      </div>
      {isOpen && (
        <ul className={`dropdown-list z-[51] ${customStyleDropdownList}`}>
          {options.map((option, index) => (
            <li
              className={`${liCustomStyle} ${index === options.length - 1 ? 'border-none' : ''}`}
              key={index}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

CustomDropdownRedux.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  customStyle: PropTypes.string,
  customStyleDropdownList: PropTypes.string,
  liCustomStyle: PropTypes.string,
  defaultValue: PropTypes.string,
  dropdownContainer: PropTypes.string,
};

export default CustomDropdownRedux;